import { oneWay } from '@ember/object/computed';
import SavedMessageEditForm from './saved-message-edit-form';

/**
 * Component for modifying an existing saved message
 */
export default SavedMessageEditForm.extend({
  /**
   * @inheritDoc
   */
  titleText: 'Edit message',

  /**
   * @inheritDoc
   */
  submitButtonText: 'Update',

  /**
   * @inheritDoc
   */
  newTitle: oneWay('message.title'),

  /**
   * @inheritDoc
   */
  newBody: oneWay('message.body'),

  /**
   * @inheritDoc
   */
  _handleSubmit() {
    return this.onSubmitForm(this.message, {
      title: this.newTitle,
      body: this.newBody,
    });
  },
});
